import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import Contact from '../components/Contact';
import SEO from '../components/SEO';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO title="Contact" path="/contact" description="Book a consultation with Dr. Venkata Pradeep Babu Koyyala, Medical Oncologist at Shankara Cancer and Research Institute, Tezpur, Assam. Contact via phone, email, or WhatsApp." keywords="Contact Dr Koyyala, Cancer Consultation Tezpur, Book Oncologist Appointment Assam, Cancer Doctor Contact" />
      <Navigation />
      
      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 bg-gradient-to-b from-teal-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Contact Us
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Schedule a consultation or reach out for medical advice
          </p>
        </div>
      </div>

      {/* Contact Content */}
      <Contact />

      {/* Office Hours & Additional Info */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Consultation Information</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-4">What to Bring</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• Previous medical records and test results</li>
                <li>• List of current medications</li>
                <li>• Insurance information (if applicable)</li>
                <li>• Pathology reports and imaging studies</li>
                <li>• List of questions or concerns</li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-4">What to Expect</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• Comprehensive medical history review</li>
                <li>• Detailed discussion of diagnosis</li>
                <li>• Explanation of treatment options</li>
                <li>• Personalized treatment plan</li>
                <li>• Opportunity to ask questions</li>
              </ul>
            </div>
          </div>

          <div className="mt-8 bg-teal-50 rounded-xl p-6 border-l-4 border-teal-700">
            <h3 className="text-xl font-bold text-gray-900 mb-3">Important Note</h3>
            <p className="text-gray-700">
              For urgent medical concerns or emergencies, please contact the hospital directly or visit the emergency department. This form is for scheduling consultations and general inquiries.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;